import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { onMounted, ref } from "vue";
import {
  SingleUserProgressSummarySchema,
  UserProgressSummarySchema,
  UserSchema,
} from "@/types";
import { displayDuration, timestampToDisplay } from "@/util";
import { getOnboardingStatistics, getUsers, getUserStatistics } from "@/api";
import {
  FlexItem,
  FlexBox,
  Typography,
  PanelCard,
  TextButton,
  SelectInput,
} from "@/components/common";


/**
 * Displays the admin page onboarding stats.
 */
const __default__ = {
  name: "OnboardingStatistics",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const stats = ref<UserProgressSummarySchema>();
const userId = ref("");
const userLoading = ref(false);
const userStats = ref<SingleUserProgressSummarySchema>();
const users = ref<UserSchema[]>([]);

onMounted(async () => {
  stats.value = await getOnboardingStatistics();
  users.value = await getUsers();
});

/**
 * Converts the duration (in seconds) to a human readable format.
 * @param duration - The duration in seconds.
 * @returns The human readable duration.
 */
function convertDuration(duration: number) {
  return displayDuration(duration * 1000);
}

/**
 * Converts the percent (out of 1) to a human readable format.
 * @param percent - The percent (out of 1).
 * @returns The human readable percent.
 */
function convertPercent(percent: number) {
  if (percent <= 0) return "-";
  return (percent * 100).toFixed(2) + " %";
}

/**
 * Loads the statistics for the given user.
 */
async function handleLoadUser() {
  if (userId.value) {
    userLoading.value = true;
    userStats.value = await getUserStatistics(userId.value).finally(() => {
      userLoading.value = false;
    });
  } else {
    userStats.value = undefined;
  }
}

return (_ctx: any,_cache: any) => {
  return (!!stats.value)
    ? (_openBlock(), _createBlock(_unref(PanelCard), {
        key: 0,
        title: "Onboarding Statistics"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FlexBox), null, {
            default: _withCtx(() => [
              _createVNode(_unref(SelectInput), {
                modelValue: userId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userId).value = $event)),
                options: users.value,
                "option-to-value": "",
                "option-label": "email",
                "option-value": "id",
                label: "User Email"
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_unref(TextButton), {
                text: "",
                l: "1",
                t: "2",
                label: "Load User",
                onClick: handleLoadUser
              })
            ]),
            _: 1
          }),
          (!userStats.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Typography), {
                  value: "Accounts",
                  variant: "subtitle",
                  el: "h3"
                }),
                _createVNode(_unref(FlexBox), { "full-width": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FlexItem), { parts: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: "Created",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Verified",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "With Tracking",
                          secondary: "",
                          el: "p"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FlexItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: stats.value.accounts.created,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: stats.value.accounts.verified,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: stats.value.accounts.haveProperProgressTracking,
                          el: "p"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Typography), {
                  value: "GitHub",
                  variant: "subtitle",
                  el: "h3"
                }),
                _createVNode(_unref(FlexBox), { "full-width": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FlexItem), { parts: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: "Accounts",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Percent",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Average Time",
                          secondary: "",
                          el: "p"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FlexItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: stats.value.github.withProperTracking.accounts,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: convertPercent(stats.value.github.withProperTracking.percent),
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: 
              convertDuration(stats.value.github.withProperTracking.averageTime)
            ,
                          el: "p"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Typography), {
                  value: "Import",
                  variant: "subtitle",
                  el: "h3"
                }),
                _createVNode(_unref(FlexBox), { "full-width": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FlexItem), { parts: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: "Total Imports",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Total Accounts",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Total Percent",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Total Average Time",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "With GitHub Accounts",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "With GitHub Percent",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "With GitHub Average Time",
                          secondary: "",
                          el: "p"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FlexItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: stats.value.imports.totalPerformed,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: stats.value.imports.total.accounts,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: convertPercent(stats.value.imports.total.percent),
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: convertDuration(stats.value.imports.total.averageTime),
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: stats.value.imports.fromGithubProper.accounts,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: convertPercent(stats.value.imports.fromGithubProper.percent),
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: convertDuration(stats.value.imports.fromGithubProper.averageTime),
                          el: "p"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Typography), {
                  value: "Summarization",
                  variant: "subtitle",
                  el: "h3"
                }),
                _createVNode(_unref(FlexBox), { "full-width": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FlexItem), { parts: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: "Total Summarizations",
                          secondary: "",
                          el: "p"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FlexItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: stats.value.summarizations.totalPerformed,
                          el: "p"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Typography), {
                  value: "Generation",
                  variant: "subtitle",
                  el: "h3"
                }),
                _createVNode(_unref(FlexBox), { "full-width": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FlexItem), { parts: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: "Total Generations",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Total Lines Generated On",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Total Accounts",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Total Percent",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Total Average Time",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "With Import Accounts",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "With Import Percent",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "With Import Average Time",
                          secondary: "",
                          el: "p"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FlexItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: stats.value.generations.totalGenerations,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: stats.value.generations.linesGeneratedOn,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: stats.value.generations.total.accounts,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: convertPercent(stats.value.generations.total.percent),
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: convertDuration(stats.value.generations.total.averageTime),
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: stats.value.generations.fromImportProper.accounts,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: convertPercent(stats.value.generations.fromImportProper.percent),
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: 
              convertDuration(stats.value.generations.fromImportProper.averageTime)
            ,
                          el: "p"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(Typography), {
                  value: "Account Statistics",
                  variant: "subtitle",
                  el: "h3"
                }),
                _createVNode(_unref(FlexBox), { "full-width": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FlexItem), { parts: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: "Imports",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Summarizations",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Generations",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Lines Generated On",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Created At",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "GitHub Linked At",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Project Imported At",
                          secondary: "",
                          el: "p"
                        }),
                        _createVNode(_unref(Typography), {
                          value: "Generated At",
                          secondary: "",
                          el: "p"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FlexItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          value: userStats.value.importsPerformed,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: userStats.value.summarizationsPerformed,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: userStats.value.generationsPerformed,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: userStats.value.linesGeneratedOn,
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: _unref(timestampToDisplay)(userStats.value.accountCreatedTime),
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: _unref(timestampToDisplay)(userStats.value.githubLinkedTime),
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: _unref(timestampToDisplay)(userStats.value.firstProjectImportedTime),
                          el: "p"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Typography), {
                          value: _unref(timestampToDisplay)(userStats.value.firstGenerationPerformedTime),
                          el: "p"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})